<template>
  <div class="table">
    <div class="table-header">
      <p>Lịch huấn luyện</p>
      <div>
        <input v-model="filterTerm" placeholder="Tên" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="addClick" class="add-new" v-if="$checkPermission('create_tschedule')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên</th>
            <th>Ngày tạo</th>
            <th>Ẩn</th>
            <th>Tạo bởi</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.name }}</td>
            <td>{{ formatDate(ctt.createdAt) }}</td>
            <!-- <td>{{ getDetailForId(ctt.subMenuId) }}</td> -->
            <td>{{ subForBoolean(ctt.hidden) }}</td>
            <td>{{ ctt.author }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_tschedule')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_tschedule')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" @vnTab="vnTab" @enTab="enTab" :hasLang="true">
    <div class="data-display">
      <div class="box"> <p>Tên<span style="color: red;">*</span></p> </div>
      <input type="text" v-model="name"/>
    </div>

    <!-- <div class="data-display">
      <div class="box"> <p>Language</p> </div>
      <select v-model="lang">
        <option value="vn">vn</option>
        <option value="en">en</option>
      </select>
    </div> -->

    <!-- <div class="data-display">
      <div class="box"> <p>SubMenu</p> </div>
      <select v-model="subMenuId">
        <option value="17">Lịch huấn luyện</option>
        <option value="36">Training Schedules</option>
      </select>
    </div> -->

    <!-- <div class="data-display">
      <div class="box"> <p>Hidden</p> </div>
      <select v-model="hidden">
        <option :value="true">true</option>
        <option :value="false">false</option>
      </select>
    </div> -->

    <div class="data-display">
      <div class="cb-box"> <p>Ẩn<span style="color: red;">*</span></p> </div>
      <div>
        <label>
          <input id="cb" type="checkbox" :checked="hidden === true" v-model="hidden" :true-value="true" :false-value="null" />
          Có
        </label>

        <label>
          <input id="cb" type="checkbox" :checked="hidden === false" v-model="hidden" :true-value="false" :false-value="null" />
          Không
        </label>
      </div>
    </div>

    <div class="btn-container">
      <button type="button" :disabled="isClicked" v-if="id === 0" @click="createClick()">Tạo</button>
      <button type="button" :disabled="isClicked" v-if="id !== 0" @click="updateClick()">Cập nhật</button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    @delete="deleteClick(selectedId)"></alert-modal>
</template>

<script>
export default {
  data () {
    return {
      menus: [],
      pageSize: 9,
      currentPage: 1,
      modalActive: false,
      modalAlert: false,
      filterTerm: '',
      appliedTerm: '',
      modalTitle: '',
      selectedId: 0,
      isLoading: false,
      extraAction: false,
      propertiesToCheck: ['vnName', 'enName', 'hidden'],
      hasCreatedData: false,
      changeLang: false,
      checkEn: false,
      loadEditData: false,
      msg: '',
      isClicked: false,
      // data
      id: 0,
      vnId: 0,
      enId: 0,
      vnName: '',
      enName: '',
      name: '',
      url: '',
      subMenuId: 17,
      hidden: false,
      lang: 'vn',
      createdAt: '',
      author: '',
      updatedAt: ''
    }
  },
  computed: {
    getTrainingSchedules () {
      return this.$store.getters['student/backendTrainingSchedules']
    },
    filterItems () {
      if (!this.appliedTerm) {
        return this.getTrainingSchedules
      }
      this.reloadPageWithFilter()
      const searchTerm = this.appliedTerm.toLowerCase()
      return this.getTrainingSchedules.filter(data =>
        data.name.toLowerCase().includes(searchTerm)
      )
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItems.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItems.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    }
  },
  watch: {
    lang (newLang) {
      if (newLang === 'en') {
        this.subMenuId = 36
      } else {
        this.subMenuId = 17
      }
    }
  },
  methods: {
    sendFilterTerm () {
      this.appliedTerm = this.filterTerm
    },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    getCurrentDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    async getTShDetailData () {
      this.isLoading = true
      await this.$store.dispatch('student/getTShData')
      this.isLoading = false
    },
    validateVariable () {
      this.isValid = true
      if (this.lang === 'vn') this.vnName = this.name
      else this.enName = this.name

      if (!this.checkEn) {
        this.isValid = false
        this.msg = 'Vui lòng kiểm tra dữ liệu phiên bản tiếng Anh một lần trước khi tiếp tục'
      } else {
        this.propertiesToCheck.forEach(key => {
          if (this[key] === '' || this[key] === 0 || this[key] === null) {
            this.isValid = false
            this.msg = 'Thiếu thông tin cần thiết'
          }
        })
      }
    },
    subForBoolean (value) {
      if (value) return 'Có'
      else return 'Không'
    },
    getDetailForId (id) {
      if (id === 17) {
        return 'Lịch huấn luyện'
      }
      return 'Training Schedule'
    },
    vnTab () {
      if (this.hasCreatedData || this.loadEditData) {
        if (this.changeLang) {
          if (this.loadEditData) this.id = this.vnId
          this.enName = this.name
          this.name = this.vnName
          this.changeLang = false
        }
        this.lang = 'vn'
      }
    },
    enTab () {
      this.checkEn = true
      if (this.hasCreatedData || this.loadEditData) {
        if (!this.changeLang) {
          if (this.loadEditData) this.id = this.enId
          this.vnName = this.name
          this.name = this.enName
          this.changeLang = true
        }
        this.lang = 'en'
      } else {
        const data = this.$store.getters['student/enBackendScheduleTab'](this.url)
        this.vnName = this.name
        this.enId = data.id
        this.id = data.id
        this.name = data.name
        this.lang = data.lang === '' ? 'en' : data.lang
        this.loadEditData = true
      }
    },
    formatDate (dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-GB')
    },
    generateUrl (name) {
      return name
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/-+/g, '-')
        .toLowerCase()
        .replace(/^-|-$/g, '')
    },
    addClick () {
      this.isClicked = false
      this.vnName = ''
      this.enName = ''
      this.hasCreatedData = true
      this.changeLang = false
      this.checkEn = false
      this.toggleModal()
      this.extraAction = false
      this.modalTitle = ' Thêm lịch huấn luyện'
      this.id = 0
      this.name = ''
      this.vnId = 0
      this.enId = 0
      this.subMenuId = 17
      this.hidden = false
      this.lang = 'vn'
      this.url = ''
    },
    async createClick () {
      this.isClicked = true
      this.validateVariable()

      if (!this.isValid) {
        this.isClicked = false
        this.$showError(this.msg)
        return
      }

      if (this.url === '') {
        this.url = '/' + this.generateUrl(this.vnData.name)
      }

      const newTSh = {
        url: this.url,
        hidden: this.hidden
      }

      try {
        if (this.hasCreatedData) {
          const vnData = {
            name: this.vnName,
            subMenuId: 17,
            ...newTSh,
            lang: 'vn'
          }

          const enData = {
            name: this.enName,
            subMenuId: 36,
            ...newTSh,
            lang: 'en'
          }

          await this.$store.dispatch('student/postTSh', vnData)
          await this.$store.dispatch('student/postTSh', enData)
        } else {
          const enMissingData = {
            name: this.enName,
            subMenuId: 36,
            ...newTSh,
            lang: 'en'
          }

          await this.$store.dispatch('student/postTSh', enMissingData)
        }

        this.$showSuccess('Thêm thành công')
        this.getTShDetailData()
        this.toggleModal()
      } catch (error) {
        this.isClicked = false
        this.$showError(error)
      }
    },
    editClick (data) {
      this.isClicked = false
      this.loadEditData = false
      this.changeLang = true
      this.checkEn = false
      this.hasCreatedData = false
      this.toggleModal()
      this.modalTitle = 'Sửa lịch huấn luyện'
      this.vnId = data.id
      this.id = data.id
      this.name = data.name
      this.subMenuId = data.subMenuId
      this.hidden = data.hidden
      this.url = data.url
      this.lang = data.lang
      this.createdAt = data.createdAt
      this.author = data.author
      this.updatedAt = data.updatedAt
    },
    async updateClick () {
      this.isClicked = true
      this.validateVariable()

      if (!this.isValid) {
        this.isClicked = false
        this.$showError(this.msg)
        return
      }

      if (this.enId === 0) {
        this.isClicked = false
        this.$showError('Có một dữ liệu en bị thiếu cần được tạo')
        return
      }

      const updatedTSh = {
        url: this.url,
        hidden: this.hidden
      }

      try {
        const vnData = {
          id: this.vnId,
          name: this.vnName,
          subMenuId: 17,
          ...updatedTSh,
          lang: 'vn'
        }

        const enData = {
          id: this.enId,
          name: this.enName,
          subMenuId: 36,
          ...updatedTSh,
          lang: 'en'
        }

        await this.$store.dispatch('student/updateTSh', vnData)
        await this.$store.dispatch('student/updateTSh', enData)

        this.$showSuccess('Cập nhật thành công')
        this.getTShDetailData()
        this.toggleModal()
      } catch (error) {
        this.isClicked = false
        this.$showError(error)
      }

      // const updatedTSh = {
      //   id: this.id,
      //   name: this.name,
      //   subMenuId: this.subMenuId,
      //   hidden: this.hidden,
      //   createdAt: this.createdAt,
      //   updatedAt: this.getCurrentDate(),
      //   author: this.author,
      //   lang: this.lang
      // }

      // await this.$store.dispatch('student/updateTSh', updatedTSh)
      // this.getTShDetailData()
      // this.toggleModal()
    },
    async deleteClick (id) {
      await this.$store.dispatch('student/deleteTSh', id)
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
        this.currentPage--
      }
      this.toggleAlert()
      this.getTShDetailData()
    }
  },
  created () {
    this.getTShDetailData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  /* /* th:nth-child(6), td:nth-child(6) {
    text-align: center;
    width: 120px;
  } */

  td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5) {
    text-align: center;
  }

  th:nth-child(6), td:nth-child(6) {
    text-align: center;
    width: 120px;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */
  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .data-display .cb-box {
    width: 100px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }

  .data-display #cb {
    height: 12px;
    width: auto;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
    margin-right: 10px;
  }

  .data-display label {
    margin-right: 80px;
  }

  .data-display #special-label {
    margin-right: 66px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
  }

  .btn-container button {
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }
</style>
